
import ClientEditableDetail from "@/components/client/ClientEditableDetail.vue";
import { IClientDetailData } from "@/entities";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({
  name: "client-edit-page",
  components: {
    ClientEditableDetail,
  },
})
export default class ClientEditPage extends Vue {
  @Action("fetchClientDetail") fetchClientDetail!: (idClient: number) => Promise<IClientDetailData>;

  public clientDetail: IClientDetailData | null = null;

  public $refs!: {
    clientEditableDetail: InstanceType<typeof ClientEditableDetail>;
  };

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    this.clientDetail = await this.fetchClientDetail(Number(this.$route.params.id));
  }

  async handleFetchClientRequired(): Promise<void> {
    this.clientDetail = await this.fetchClientDetail(Number(this.$route.params.id));
    this.$nextTick(() => {
      this.$refs.clientEditableDetail.intiializeFormData();
    });
  }
}
